export interface ApiSearchSocketJobRequest {
    socket_type: string | 'COPILOT_VIEW';
}

export interface ApiSearchSocketJobResponse {
    job_id: string;
    sock_path: string;
}

export const SearchSocketJob = Symbol('SearchSocketJob');

export interface SearchSocketJob {
    searchSocketJob(data: ApiSearchSocketJobRequest): Promise<ApiSearchSocketJobResponse>;
}
